import React from "react";
import { Paper, Stack } from "@mui/material";
import generalActionsStyle from "./generalActionsStyle";
import ActionButton from "../Actions/ActionButton";
import _ from "lodash";
import { getGeneralActionsByUser } from "../../services/navigationActionsService";
import { useCurrentUser } from "../../provider/CurrentUserProvider";

const GeneralActions = () => {
  const currentUser = useCurrentUser();
  const actions = getGeneralActionsByUser(currentUser);

  return (
    <Stack component={Paper} sx={[generalActionsStyle.actionsContainer, {
      alignItems: "center",
    }]}>
      {_.map(actions, (action, index) => (
        <React.Fragment key={index}>
          <ActionButton {...action} href={undefined} useCondensedView={false} />
        </React.Fragment>
      ))}
    </Stack>
  );
};

export default GeneralActions;
